import axios from '@/utils/request'

// const agentLoginUrl = '/date/user/agentLogin'
const dateBoardUrl = '/data/frontPage/dateBoard'
const dateBoard = async (body) => {
  const { data } = await axios.post(dateBoardUrl, body)
  return data.data
}

const panelUrl = '/data/frontPage/panel'
const panel = async (body) => {
  const { data } = await axios.post(panelUrl, body)
  return data.data
}

const newRegisterUrl = '/data/frontPage/newRegister'
const newRegister = async (body) => {
  const { data } = await axios.post(newRegisterUrl, body)
  return data.data
}

const firstWithdrawUrl = '/data/firstWithdraw/list'
const firstWithdraw = async (body) => {
  const { data } = await axios.post(firstWithdrawUrl, body)
  return data.data
}

const firstTradeUrl = '/data/firstTrade/list'
const firstTrade = async (body) => {
  const { data } = await axios.post(firstTradeUrl, body)
  return data.data
}

const coinInfoUrl = '/account/get/trade/coinId/info'
const coinInfo = async (body) => {
  const { data } = await axios.post(coinInfoUrl, body, { auth: false })
  return data.data
}

const panelCommissionUrl = '/data/frontPage/panelCommission'
const panelCommission = async (body) => {
  const { data } = await axios.post(panelCommissionUrl, body)
  return data.data
}

const panelNewRegisterUrl = '/data/frontPage/panelNewRegister'
const panelNewRegister = async (body) => {
  const { data } = await axios.post(panelNewRegisterUrl, body)
  return data.data
}

const panelUserUrl = '/data/frontPage/panelUser'
const panelUser = async (body) => {
  const { data } = await axios.post(panelUserUrl, body)
  return data.data
}

const panelTradeUrl = '/data/frontPage/panelTrade'
const panelTrade = async (body) => {
  const { data } = await axios.post(panelTradeUrl, body)
  return data.data
}

const panelDepositUrl = '/data/frontPage/panelDeposit'
const panelDeposit = async (body) => {
  const { data } = await axios.post(panelDepositUrl, body)
  return data.data
}

const needLoginUrl = []

export default {
  needLoginUrl,
  dateBoard,
  panel,
  newRegister,
  firstWithdraw,
  firstTrade,
  coinInfo,
  panelCommission,
  panelNewRegister,
  panelUser,
  panelTrade,
  panelDeposit,
}
